/** Assembles keyboard-nav props from useKeyboardNavProps inputs. */
export function buildKeyboardNavPropsObject({
  tasks,
  allTasks,
  selectedIndex,
  handleKeyboardSelect,
  openNewTaskInput,
  isNewTaskInputActive,
  handleToggleComplete,
  handleDeleteTask,
  updateTask,
  triggerFollowUp,
  handleStartFocus,
  stopFocus,
  activeFocusTaskId,
  navigate,
  pathname,
  user,
  onStartEditing,
  editingTaskId,
  deselectAllTasks,
  isFocused,
  view,
  planMode,
  disableStructuralNav,
  disableRowNavigate,
  handleStartAddingSubtask,
  addingSubtaskTo,
}) {
  return {
    filteredTasks: tasks,
    allTasks,
    selectedIndex,
    setSelectedIndex: handleKeyboardSelect,
    onShowNewTaskInput: openNewTaskInput,
    isNewTaskInputActive,
    handleToggleComplete,
    handleDeleteTask,
    updateTask,
    triggerFollowUp,
    handleStartFocus,
    stopFocus,
    activeFocusTaskId,
    navigate,
    pathname,
    userId: user?.uid,
    onStartEditing,
    editingTaskId,
    deselectAllTasks,
    isFocused,
    allowIndentToRoot: true,
    allowOutdentToRoot: view !== 'subtask',
    view,
    planMode,
    disableStructuralNav,
    disableRowNavigate,
    handleStartAddingSubtask,
    addingSubtaskTo,
  };
}
